'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = decorate;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var node = _propTypes.PropTypes.node,
    oneOfType = _propTypes.PropTypes.oneOfType,
    func = _propTypes.PropTypes.func;
function decorate(componentName) {
	var displayName = 'LeafletUniv' + componentName;

	var Decorated = function (_Component) {
		(0, _inherits3.default)(Decorated, _Component);

		function Decorated(props) {
			(0, _classCallCheck3.default)(this, Decorated);

			var _this = (0, _possibleConstructorReturn3.default)(this, (Decorated.__proto__ || (0, _getPrototypeOf2.default)(Decorated)).call(this, props));

			_this.state = { loaded: false };
			_this.constructor.displayName = displayName;
			return _this;
		}

		(0, _createClass3.default)(Decorated, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setState(function () {
					return { loaded: true };
				});
				this.ClientComponent = require('react-leaflet')[componentName];
			}
		}, {
			key: 'render',
			value: function render() {
				if (!this.state.loaded) return null;

				var ClientComponent = this.ClientComponent;
				var _props = this.props,
				    children = _props.children,
				    leafletRef = _props.leafletRef,
				    rest = (0, _objectWithoutProperties3.default)(_props, ['children', 'leafletRef']);

				var childComponents = typeof children === 'function' ? children() : children;

				return _react2.default.createElement(
					ClientComponent,
					(0, _extends3.default)({}, rest, { ref: leafletRef }),
					childComponents
				);
			}
		}]);
		return Decorated;
	}(_react.Component);

	Decorated.displayName = displayName;
	Decorated.propTypes = {
		children: oneOfType([node, func]),
		leafletRef: func
	};

	return Decorated;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-leaflet-universal/dist/decorator.js
// module id = 2625
// module chunks = 0